export default function DetailContents() {
  return (
    <div>
      <h1 className="mt-[37px] mb-[45px] text-left text-[22px] font-semibold">
        세부 내용
      </h1>
      <div className="text-gray-1100 space-y-6 text-left">
        <p>
          대학생 연합 IT 동아리 잇타(IT's TIME)에서 6기 신입회원을 모집합니다!
        </p>

        <p>
          잇타는 'IT's TIME'의 줄임말로, '이제 ________ 할 시간'이라는 의미를
          담고 있습니다. 세상에 없던 새로운 서비스, 상상만 해도 즐거운 프로젝트,
          사업성 높은 아이디어들, 이 모든 IT 꿈들을 현실로 만드는 대학생 연합 IT
          동아리입니다.
        </p>

        <p>이제는 꿈을 이룰 시간, 바로 잇타와 함께하세요.</p>

        <div className="space-y-1">
          <p>🔥 활동 내용</p>
          <p>- 웹/앱 팀 프로젝트</p>
          <p>- 동아리 정규 프로그램</p>
          <p>- 분야별 스터디</p>
          <p>- IT's TRIP (잇타 MT)</p>
          <p>- 뒤풀이 등 친목 교류 프로그램</p>
        </div>

        <div className="space-y-1">
          <p>📅 모집 일정</p>
          <p>- 1차 서류 모집: 8월 15일(목) ~ 8월 25일(일) 23:59</p>
          <p>- 1차 합격자 발표: 8월 29일(목) (개별 문자 발표)</p>
          <p>- 2차 면접 (비대면, 게더타운): 8월 30일(금) ~ 9월 2일(월)</p>
          <p>- OT: 9월 14일(토) (대면 필참)</p>
        </div>

        <div className="space-y-1">
          <p>🙌 모집 대상</p>
          <p>
            - 수도권 대학생 (재학생, 휴학생, 졸업유예생 모두 가능 / 단, 24년도
            8월 졸업생 지원불가)
          </p>
          <p>- 매달 2회 토요일 정규 프로그램에 빠짐없이 참여 가능한 사람</p>
          <p>- 팀 활동 및 회의에 성실히 참여 가능한 사람</p>
          <p>- 책임감과 애정을 갖고 팀 프로젝트에 진심을 다할 수 있는 사람</p>
          <p>- 팀원들과 원활한 의사소통이 가능한 사람</p>
          <p>- 팀 프로젝트에서 문제 상황을 해결해 본 경험이 있는 사람</p>
        </div>

        <div className="space-y-2">
          <p>🎈 모집 분야 및 자격 요건</p>
          <div className="space-y-1">
            <p>1. 기획 파트</p>
            <p>- 기획의 기본 흐름을 알고 IT 서비스 기획을 경험해 본 사람</p>
            <p>- 기획하고 싶은 서비스에 대한 아이디어가 있는 사람</p>
            <p>
              - 기획 파트의 경우, OT 때 진행하는 기획 세미나에서 자신의
              아이디어를 간단하게 발표해야 합니다.
            </p>
          </div>

          <div className="space-y-1">
            <p>2. 디자인 파트</p>
            <p>- 프로젝트 경험이 있고, 피그마를 다룰 줄 아는 사람</p>
            <p>- 서비스에 맞는 디자인을 할 수 있는 사람</p>
          </div>

          <div className="space-y-1">
            <p>3. 개발 파트 (웹 프론트엔드, 앱 프론트엔드, 백엔드)</p>
            <p>
              - 개발 프로젝트 경험이 있고, 이를 증명할 수 있는 깃허브 계정이
              있는 사람
            </p>
            <p>- 다른 파트의 팀원들과 원활히 소통할 줄 아는 사람</p>
          </div>

          <div className="space-y-1">
            <p>4. 우대사항</p>
            <p>- 프로젝트 리딩 경험이 있는 사람</p>
          </div>
        </div>

        <div className="space-y-1">
          <p>⭐️ 지원 방법</p>
          <p>- 지원 구글폼은 프로필 링크를 참고해주세요.</p>
          <p>
            - 중복 지원 가능하나, 지원하실 모든 파트의 지원서를 각각
            제출해주셔야 합니다.
          </p>
          <p>
            - 지원서 제출은 8월 25일(일) 23:59 까지이니 기한을 준수해주시기
            바랍니다.
          </p>
        </div>

        <div className="space-y-1">
          <p>⏰ 정규 프로그램 일정 [2024.09 ~ 2025.01]</p>
          <p>- OT + 기획 세미나: 9월 14일</p>
          <p>- 아이디어 발표회: 9월 28일</p>
          <p>- 네트워킹 데이 1회차: 10월 12일</p>
          <p>- IT's TRIP: 10월 12일</p>
          <p>- 중간 발표회: 11월 16일</p>
          <p>- 디자인 세미나 (비대면): 11월 3째주</p>
          <p>- 집중 개발 행사: 11월 30일</p>
          <p>- 네트워킹 데이 2회차: 12월 7일</p>
          <p>- 해커톤 with OB: 12월 중</p>
          <p>- 개발 세미나: 12월 중</p>
          <p>- 현직자와의 만남: 1월 4일</p>
          <p>- 최종 발표회: 1월 18일</p>
          <p className="text-sm">** 추후 프로그램 일정이 변동될 수 있습니다.</p>
        </div>

        <div className="space-y-1">
          <p>⚠️ 유의 사항</p>
          <p>
            - 동아리 정규 프로그램에는 모든 동아리원들이 필수로 참여해야 합니다.
            (대면 진행)
          </p>
          <p>
            - 합격 후 OT(9월 14일)에 불참할 경우, 동아리 합격이 취소될 수
            있습니다.
          </p>
          <p>
            - 무단으로 정규 프로그램에 불참할 경우 불이익이 발생할 수 있습니다.
          </p>
          <p>
            - 회비는 기수당 5만 원으로, 매달 동아리 행사 운영비로 사용됩니다.
            (이용 내역은 투명하게 공개됩니다.)
          </p>
          <p>- 대학교 4학년 2학기 재학생 및 졸업유예생도 지원 가능합니다.</p>
          <p>
            - 활동은 1기수(6개월)이 기본이며 2기수(1년)까지만 연장 가능합니다.
            다만, 운영진을 지원하시는 경우 추가 연장 가능합니다.
          </p>
        </div>

        <div className="space-y-1">
          <p>☎️ 공식 페이지 및 문의 채널</p>
          <p>
            - 잇타 6기 모집 공고 및 공식 홈페이지는 프로필 링크를 참고해주세요.
          </p>
          <p>- 이메일 | ita.itstime@gmail.com</p>
          <p>- 인스타그램 공식 계정 | @its_stime_</p>
        </div>
      </div>
    </div>
  );
}
